import { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface InternalProject {
  projektnummer: string;
  name: string;
  internalHours: number;
  absenceHours: number;
  totalHours: number;
}

interface InternalProjectTableProps {
  project: InternalProject | null;
  year: number;
  monthName: string;
  isMonthFiltered?: boolean;
  onProjectSelect?: (projectNumber: string) => void;
  selectedProjectNumber?: string | null;
}

export function InternalProjectTable({ 
  project, 
  year, 
  monthName, 
  isMonthFiltered = false,
  onProjectSelect,
  selectedProjectNumber = null
}: InternalProjectTableProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleProjectNameClick = (projectNumber: string, e: React.MouseEvent) => {
    e.stopPropagation();
    if (onProjectSelect) {
      if (selectedProjectNumber === projectNumber) {
        onProjectSelect(null as any);
      } else {
        onProjectSelect("000");
      }
    }
  };

  return (
    <div className="ov-p-6">
      <div 
        className="ov-flex ov-justify-between ov-items-center ov-mb-4 ov-cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="ov-flex ov-items-center ov-gap-3">
          <h3 className="ov-text-gray-900">
            Internes Projekt ({isMonthFiltered ? monthName : 'Year to Date'} {year})
            {project && selectedProjectNumber === project.projektnummer && (
              <span className="ov-text-green-600 ov-ml-2">(gefiltert: {project.projektnummer} - {project.name})</span>
            )}
          </h3>
        </div>
        <button className="ov-text-gray-500 ov-hover:text-gray-700 ov-bg-transparent ov-border-none ov-outline-none">
          {isExpanded ? <ChevronUp className="ov-w-5 ov-h-5" /> : <ChevronDown className="ov-w-5 ov-h-5" />}
        </button>
      </div>

      {isExpanded && project && (
      <div className="ov-overflow-x-auto">
        <table className="ov-w-full ov-text-xs">
          <thead>
            <tr className="ov-border-b ov-border-gray-200">
              <th className="ov-py-3 ov-px-2 ov-text-left ov-text-gray-600">Projekt-ID</th>
              <th className="ov-py-3 ov-px-2 ov-text-left ov-text-gray-600">Projektname</th>
              <th className="ov-py-3 ov-px-2 ov-text-right ov-text-gray-600">Interne Stunden</th>
              <th className="ov-py-3 ov-px-2 ov-text-right ov-text-gray-600">Absenzen Stunden</th>
              <th className="ov-py-3 ov-px-2 ov-text-right ov-text-gray-600">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`ov-border-b ov-border-gray-100 ${
              selectedProjectNumber === project.projektnummer ? 'ov-bg-green-100' : ''
            }`}>
              <td className="ov-py-3 ov-px-2 ov-text-gray-700">{project.projektnummer}</td>
              <td 
                className="ov-py-3 ov-px-2 ov-text-gray-900 ov-cursor-pointer ov-hover:text-blue-600 ov-font-medium"
                onClick={(e) => handleProjectNameClick(project.projektnummer, e)}
              >
                {project.name}
              </td>
              <td className="ov-py-3 ov-px-2 ov-text-right ov-text-gray-900">{project.internalHours.toFixed(2)}h</td>
              <td className="ov-py-3 ov-px-2 ov-text-right ov-text-gray-900">{project.absenceHours.toFixed(2)}h</td>
              <td className="ov-py-3 ov-px-2 ov-text-right ov-text-gray-900">{project.totalHours.toFixed(2)}h</td>
            </tr>
          </tbody>
        </table>
      </div>
      )}
    </div>
  );
}

